const labels = {
  // system events
  "runtime:start": "Runtime start",
  "runtime:end": "Runtime end",
  "message:reply": "Message reply",
  "outbound-delivery-status": "Outbound delivery status",
  milestone: "Milestone",
  "form-render": "Form render",
  "form-submitted": "Form submitted",
  "form-accessed": "Form accessed",
  "component:package": "Component package",
  // Actions
  "start:runtime": "Start a workflow",
  "stop:runtime": "Stop this workflow",
  "stop:process": "Stop the process",
  "start:broadcast": "Start broadcast",
  // form
  "form:reject": "Reject form",
  "form:redirect": "Redirect to another page",
  "form:reply-to-variable": "Form reply to variable",
  "form-question": "Form question",
  "form-message": "Form message",
  "form-complete-message": "Override complete message",
  "form-complete-early": "Complete the form early",
  "form:book-event": "Book event",

  // reply actions
  AddResponderToDynamicContactSet: "Add recipient to workflow context",
  RemoveResponderFromDynamicContactSet:
    "Remove recipient from workflow context",
  AddResponderToContactSet: "Add recipient to group",
  RemoveResponderFromContactSet: "Remove recipient from group",
  StoreReplyToVariable: "Store reply to variable",
  setDynamicComms: "Set dynamic comms",

  FlowReturn: "Flow return",
  AddStarterToContactSet: "Add starter to group",
  RemoveStarterFromContactSet: "Remove starter from group",
  AddStarterToDynamicContactSet: "Add starter to workflow context",
  RemoveStarterFromDynamicContactSet: "Remove starter from workflow context",
  AddDynamicContactSetToContactSet: "Add contacts in workflow context to group",
  RemoveDynamicContactSetFromContactSet:
    "Remove contacts in workflow context from group",
  RemoveAllFromDynamicContactSet: "Remove all contacts from workflow context",
  RemoveAllFromContactSet: "Remove all from group",
  "restart:runtime": "Restart runtime",

  customEvent: "Custom event",
  setMilestone: "Set milestone",
  "milestone:cancel": "Cancel milestone",
  UpdateVariable: "Update variable value",
  "extractText:inputArgument": "Extract variables from text",
  StoreInputArgumentToDynamicContactSet:
    "Store contact from variable to workflow context",
  "assets:to-context-by-name": "Load asset to workflow context",
  "assets:to-variable": "Load assets to variable",
  "assets:context-load": "Load assets to context by location",
  "assets:context-clear": "Clear assets from context",
  "assets:contacts-to-variable": "Find contacts related to an asset",
  ForwardEvent: "Forward runtime event",
  SetCounter: "Set number variable",
  Calendar: "Calendar",
  "time-zone:from-location": "Location to time zone",
  editContact: "Edit contact",
  "reporting:new-entry": "Create reporting entry",
  "reporting:load-entry": "Load reporting entry",

  "ticket:create": "Create new ticket",
  "ticket:load": "Load ticket",
  "ticket:set-status": "Set ticket status",

  startedByToVariable: "Store starter in variable",
  recipientToVariable: "Store recipient in variable",
  "workflow:contacts-to-variable":
    "Store workflow runtime filter contacts in variable",
  mergeVariables: "Copy items from one variable to another",
  "get-filenames": "Get file names from a variable",
  subtractVariables: "Remove items from a variable that match another variable",
  uniqueVariables: "Remove duplicate items from a variable",
  "variables:move-one-to-another": "Move item from one variable to another",
  "variables:delete-one": "Delete item from variable",
  "ai:prompt": "AI Prompt",
  "asset:groups-to-variable": "Copy groups from selected assets",
  "add-log-entry": "Add a log entry",

  // Conditions
  "runtime:repetitionCounter": "Runtime repetition counter",
  "reply:message": "Reply",
  triggerChannel: "Trigger channel",
  // Operator
  "compare:eq": "is equal to",
  "compare:gt": "is greater than",
  "compare:gte": "is greater than or equal to",
  "compare:lt": "is less than",
  "compare:lte": "is less than or equal to",
  "compare:between": "is between",
  keyword: "keyword",
  hasPrefix: "starts with",
  contains: "contains",
  exists: "exists",
  "api:make-request": "Make API request",
  "extract:from-data-structure": "Extract from data structure",
  "contact:load": "Load contact into contact variable",
  "contact:first-or-create": "First or create contact",
  "contact:delete": "Delete contact",
  "contact:get-location": "Get contact location",
  "contact:update-location": "Update contact location",
  "contact:add-to-group": "Add contact to group",
  "contact:remove-from-group": "Remove contact from group",
  "event:create": "Create event",
  "event:close-all": "Close all events",
  "event:find-by-ticket": "Find event by ticket",
  "event:find-by-reference": "Find event by system reference",
  "event:find-by-user-reference": "Find event by user reference",
  "event:assets": "Add/remove assets to event",
  "event:tickets": "Add/remove tickets to event",
  "event:contacts": "Add/remove contacts to event",
  "event:update": "Update event details",
  "event:status-update": "Update event status",
  "event:locations": "Update event locations",
  "component:start": "Start a component",
  "component:accept-package": "Accept component package",
};

export default labels;
